module.exports = __webpack_public_path__ + "img/docx.5aad4397.png";